import React from 'react';
import { useTranslation } from 'react-i18next';

export const EngineeringPrinciples: React.FC = () => {
  const { t } = useTranslation();

  const pillars = [
    { codeKey: 'principles.p1Code', titleKey: 'principles.p1Title', descKey: 'principles.p1Desc' },
    { codeKey: 'principles.p2Code', titleKey: 'principles.p2Title', descKey: 'principles.p2Desc' },
    { codeKey: 'principles.p3Code', titleKey: 'principles.p3Title', descKey: 'principles.p3Desc' },
    { codeKey: 'principles.p4Code', titleKey: 'principles.p4Title', descKey: 'principles.p4Desc' },
  ];

  return (
    <section className="py-16 border-b border-gray-800/80">
      <div className="mb-10">
        <span className="text-xs font-mono text-[#00F0FF] tracking-widest">{t('principles.badge')}</span>
        <h2 className="text-2xl sm:text-3xl font-bold text-white mt-1">{t('principles.title')}</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 font-mono">
        {pillars.map((pillar) => (
          <div key={pillar.codeKey} className="bg-[#090C13] border border-gray-800 p-6 space-y-3 hover:border-[#00F0FF]/30 transition-colors flex flex-col justify-between">
            <div className="space-y-3">
              <div className="text-[#00F0FF] text-xs">{t(pillar.codeKey)}</div>
              <h3 className="text-base font-bold text-white font-sans">{t(pillar.titleKey)}</h3>
              <p className="text-xs text-gray-400 font-sans leading-relaxed">
                {t(pillar.descKey)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
